import { segmentSchema } from "@redotech/redo-customer-segments-common/marketing/segments/segment-zod-schema";
import * as z from "zod";

export const getSegmentCount = {
  name: "getSegmentCount" as const,
  description:
    "How many customers a set of conditions matches, split by email and SMS eligibility. Call it to check a segment matches a sensible audience before creating it.",
  mutates: false,
  input: z.object({
    segment: segmentSchema,
    searchString: z.string().optional(),
  }),
  output: z.object({
    allCount: z.number(),
    emailEligibleCount: z.number(),
    emailSubscriberCount: z.number(),
    smsSubscriberCount: z.number(),
  }),
};
